var map = {
	"./etsy.svg": 4653,
	"./favicon.svg": 298,
	"./poweredHubster.svg": 1655,
	"./poweredOtter.svg": 7688,
	"./tiktokLogo.svg": 2329,
	"./twitter.svg": 3267,
	"./yelp.svg": 9412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8016;